






















































































































































































































































































import ApiHelper from 'api-helper';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import Toast from '@common/helpers/toast';
import PageLoader from '@components/common/PageLoader.vue';
import { PLAN_PAYMENT_TYPE } from '@/common/constants/plan';
import moment from 'moment';
import { extend } from 'vee-validate';
import {
  makeUserTreatmentState,
  NEW_USER_STATE,
  USER_STATE,
  USER_TREATMENT_STATE,
  USER_TREATMENT_STATE_CAN_RESERVE,
} from '@/common/constants/auth';
import { State } from 'vuex-class';
import { UserTreatment } from '@/models/user-treatment';
import { Patient } from '@/models/patient';
import PlanItem from '../PlanItem.vue';

extend('notSpecialChar', (text) => {
  const textCompare = text;
  if (text) {
    return textCompare.replace(
      /([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/g,
      '',
    ).length == text.length
      ? true
      : '絵文字または特殊記号を入力しないでください。';
  }
  return true;
});

@Component({
  components: {
    PageLoader,
    PlanItem,
  },
  filters: {
    formatTime(value) {
      return (value ? moment(value) : moment()).format('YYYY年 MM月DD日 HH:mm');
    },
    formatDate(value) {
      return (value ? moment(value) : moment()).format('YYYY年MM月DD日');
    },
  },
})
export default class PrescriptionPopup extends Vue {
  @State((state) => state.patient_detail.data) currentPatient!: Patient;
  @State((state) => state.treatment_detail.data) activeTreatment: UserTreatment;
  @State((state) => state.patient_detail.data) patient: Patient;
  @Prop() changeState: any;
  @Prop() listPlanByMenuKarte!: any[];
  @Prop() listFeedback!: any[];
  @Prop({ default: '' }) prescriptionTypeInfo!: string;

  paginate = {
    page: 1,
    per_page: 20,
    last_page: 1,
  };

  filterParams = {
    with: 'medicines',
    select_fields: 'id,name,treatment_policy',
    clinic_id: null,
    karte_status: 1,
    has_plans: 1,
    clinic_ids: [] as number[],
    ids_not_in: [] as number[],
  };

  get queryParams() {
    return {
      ...this.filterParams,
      ...this.paginate,
    };
  }

  private get prescriptionFormRef() {
    return this.$refs.prescriptionForm as any;
  }
  @Prop() currentChannelUser!: any;
  @Prop() changeCurrentChannelUser!: any;

  protected PRESCRIPTION_TYPE = {
    PRESCRIPTION: 'prescription',
    NG: 'ng',
    CANCEL_PRESCRIPTION: 'cancel_prescription',
    RESERVE_PRESCRIPTION: 'reserve_prescription',
  };
  private isSubmitting: boolean = false;
  private isLoading: boolean = false;
  private listPlanByMenu: any[] = [];
  private listPlanWithMenu: any[] = [];
  private listPlanIdWithMenu: any[] = [];
  private selectedPlans: any[] = [];

  private PLAN_PAYMENT_TYPE: any = PLAN_PAYMENT_TYPE;
  private prescriptionForm: any = {
    content: null,
    type: null,
    plans: [],
  };
  private isPrescription: boolean = false;
  private isNG: boolean = false;
  private isCancel: boolean = false;
  private isReverse: boolean = false;
  private prescriptionType: string = '';
  private planSuggestListEl: Element | null;

  private get checkButtonReserve() {
    return (
      this.activeTreatment.feedback_type ===
      NEW_USER_STATE.DOCTOR_RESERVE_PRESCRIPTION
    );
  }

  private get checkDoctorReserve() {
    return !USER_TREATMENT_STATE_CAN_RESERVE.includes(
      this.activeTreatment.state,
    );
  }

  private get isSelectedTreatment(): boolean {
    return [
      USER_TREATMENT_STATE.SELECTED_TREATMENT,
      USER_TREATMENT_STATE.CONFIRMED_RESERVATION,
      USER_TREATMENT_STATE.REGISTERED_INTERVIEW,
    ].includes(this.activeTreatment.state);
  }

  private get isDisabled(): boolean {
    return this.isSubmitting || (this.prescriptionForm.id > 0 && !this.isReverse);
  }

  private get hasMatchedPlans(): boolean {
    return this.matchedMenus.length > 0 && this.matchedMenus[0].plans && this.matchedMenus[0].plans.length > 0;
  }

  @Watch('prescriptionTypeInfo')
  onVisibleChange(newValue: boolean) {
    if (newValue) {
      this.prescriptionType = this.prescriptionTypeInfo ?? '';
      switch (this.prescriptionType) {
        case this.PRESCRIPTION_TYPE.PRESCRIPTION:
          this.prescriptionHandle();
          break;
        case this.PRESCRIPTION_TYPE.NG:
          this.ngHandle();
          break;
        case this.PRESCRIPTION_TYPE.CANCEL_PRESCRIPTION:
          this.cancelPrescription();
          break;
        case this.PRESCRIPTION_TYPE.RESERVE_PRESCRIPTION:
          this.reservePrescription();
          break;
      }
    }
  }

  mounted() {
    if (!this.prescriptionForm.id) {
      this.getListPlansWithMenu();
    }
  }

  private get isDisableButtonSave() {
    if (this.isPrescription || this.isNG || this.isCancel || this.isReverse) {
      return false;
    } else {
      return true;
    }
  }

  private get maxPrescriptionId(): number {
    const listFeedback = (this.$parent as any)?.listFeedback || [];
    return Math.max(...listFeedback.map((p) => p.id), 0);
  }

  private get isCancelPrescriptionDisabled(): boolean {
    return (
      this.isSubmitting ||
      this.activeTreatment.state !== USER_TREATMENT_STATE.CANCEL_REQUESTED ||
      (this.prescriptionForm.id > 0 && this.prescriptionForm.id !== this.maxPrescriptionId) ||
      ((this.prescriptionForm.type === 'ng' || this.prescriptionForm.type === 'prescription') && this.prescriptionForm.id > 0)
    );
  }

  private get isPrescriptionDisabled(): boolean {
    return (
      this.isSelectedTreatment ||
      (this.prescriptionForm.id > 0 && this.prescriptionForm.id !== this.maxPrescriptionId) ||
      ([this.PRESCRIPTION_TYPE.NG, this.PRESCRIPTION_TYPE.CANCEL_PRESCRIPTION].includes(this.prescriptionForm.type) && this.prescriptionForm.id > 0)
    );
  }

  private get isNgDisabled(): boolean {
    return (
      this.isSelectedTreatment ||
      (this.prescriptionForm.id > 0 && this.prescriptionForm.id !== this.maxPrescriptionId) ||
      ([this.PRESCRIPTION_TYPE.PRESCRIPTION, this.PRESCRIPTION_TYPE.CANCEL_PRESCRIPTION].includes(this.prescriptionForm.type) && this.prescriptionForm.id > 0)
    );
  }

  private get isReservePrescriptionDisabled(): boolean {
    return (
      this.isSubmitting ||
      this.checkDoctorReserve ||
      this.checkButtonReserve ||
      (this.prescriptionForm.id > 0 && this.prescriptionForm.id !== this.maxPrescriptionId) ||
      ([this.PRESCRIPTION_TYPE.NG, this.PRESCRIPTION_TYPE.PRESCRIPTION, this.PRESCRIPTION_TYPE.CANCEL_PRESCRIPTION].includes(this.prescriptionForm.type) && this.prescriptionForm.id > 0)
    );
  }

  show(currentPrescription) {
    this.prescriptionForm = currentPrescription;
    this.prescriptionType = currentPrescription.type;

    if (this.prescriptionForm && this.prescriptionForm.id) {
      this.isPrescription = this.prescriptionType === this.PRESCRIPTION_TYPE.PRESCRIPTION;
      this.isNG = this.prescriptionType === this.PRESCRIPTION_TYPE.NG;
      this.isCancel = this.prescriptionType === this.PRESCRIPTION_TYPE.CANCEL_PRESCRIPTION;
      this.isReverse = this.prescriptionType === this.PRESCRIPTION_TYPE.RESERVE_PRESCRIPTION;
    }

    this.$modal.show('prescriptionForm');
  }

  getListPlansWithMenu() {
    this.isLoading = true;
    const self = this;
    const payload = { user_treatment_id: this.activeTreatment.id, with: ['medicines:id,name,usage'] };
    ApiHelper.getApi('PatientV2Api')
      .getPlansByPatientId(this.currentChannelUser.id, payload)
      .then(function(res) {
        self.listPlanWithMenu = res.data;
        self.listPlanIdWithMenu = res.data?.map((plan) => plan.id) || [];
        self.$emit('updateListPlanWithMenu', self.listPlanWithMenu);

        // No-75 Displays a list of non-clinic services
        // self.getListPlans();
      })
      .catch((error: any) => {
        Toast.error(error.response.data.message);
      })
      .finally(function() {
        self.isLoading = false;
      });
  }

  getListPlans() {
    this.isLoading = true;
    const self = this;

    if ((this.paginate.page > this.paginate.last_page && this.paginate.last_page >= 1) ||
        (this.listPlanByMenu.length > 0 && this.listPlanByMenu.length < this.paginate.per_page)) {
      this.isLoading = false;
      return;
    }

    if (this.currentPatient && this.currentPatient.clinics.length > 0) {
      this.filterParams.clinic_ids = [this.patient.clinics[0].id];
    }

    this.filterParams.ids_not_in = this.activeTreatment?.menu?.id
      ? [this.activeTreatment.menu.id]
      : [];

    ApiHelper.getApi('MedicalMenuV2Api')
      .fetchPlanListV2(this.queryParams)
      .then((res) => {
        const lastPage = res ? res.meta.last_page : 1;
        if (self.paginate.page * self.paginate.per_page > self.listPlanByMenu.length + res.data.length - 1) {
          let plans = res.data || [];
          if (self.listPlanIdWithMenu.length > 0) {
            plans = plans.filter((plan) => !self.listPlanIdWithMenu.includes(plan.id));
          }
          self.listPlanByMenu = [...self.listPlanByMenu, ...plans];
        }

        self.paginate = {
          ...self.paginate,
          page: lastPage >= self.paginate.page ? self.paginate.page + 1 : self.paginate.page,
          last_page: lastPage,
        };
      })
      .catch((error: any) => {
        Toast.error(error.response.data.message);
      })
      .finally(() => {
        this.isLoading = false;
      });
  }

  get lpPlans() {
    return this.listPlanWithMenu.filter((plan) => plan.selected_from_lp === true);
  }

  get otherPlans() {
    if (this.prescriptionForm.id == null) {
      const filteredPlans = this.listPlanWithMenu.filter((plan) => !plan.selected_from_lp);
      return filteredPlans;
    }
    return [];
  }

  get recommendedPlanIds() {
    return this.prescriptionForm.listPlans.filter((plan) => plan.pivot.recommended).map((plan) => plan.id);
  }

  get matchedMenus() {
    const menuList = (this.$parent as any)?.listPlanByMenuKarte || [];
    const activeMenuId = this.activeTreatment?.menu?.id;
    if (!activeMenuId) {
      return [];
    }

    const recommendedIds = new Set(this.recommendedPlanIds);
    const matched = menuList.filter((m) => m.id === activeMenuId);

    const lpIds = new Set((this.listPlanWithMenu || [])
      .filter((p) => p.selected_from_lp)
      .map((p) => p.id));

    if (!matched.length) {
      const plans = (this.listPlanWithMenu || [])
        .filter((p) => !lpIds.has(p.id))
        .map((p) => ({
          ...p,
          recommended: recommendedIds.has(p.id),
        }));

      return [
        {
          id: activeMenuId,
          name: this.activeTreatment?.menu?.name,
          plans,
        },
      ];
    }

    // Filter menus that match the activeTreatment.menu.id
    return matched.map((menu) => {
      const existingPlanIds = new Set((menu.plans || []).map((p) => p.id));

      const mergedPlans = [
        ...(menu.plans || []),
        ...(this.prescriptionForm?.listPlans || []).filter(
          (p) => !existingPlanIds.has(p.id),
        ),
      ];

      const plans = mergedPlans
        .filter((p) => !lpIds.has(p.id))
        .map((p) => ({
          ...p,
          recommended: recommendedIds.has(p.id),
        }));

      return { ...menu, plans };
    });
  }

  get duplicatedPlans() {
    const menuList = (this.$parent as any)?.listPlanByMenuKarte || [];
    const activeMenuId = this.activeTreatment?.menu?.id;
    if (!activeMenuId) {
      return [];
    }

    const recommendedIds = new Set(this.recommendedPlanIds);
    const lpIds = new Set((this.lpPlans || []).map((p) => p.id));
    const matchedMenu = menuList.find((m) => m.id === activeMenuId);

    if (!matchedMenu) {
      return (this.lpPlans || []).map((p) => ({
        ...p,
        recommended: recommendedIds.has(p.id),
      }));
    }

    return (matchedMenu.plans || [])
      .filter((p) => lpIds.has(p.id))
      .map((p) => ({
        ...p,
        recommended: recommendedIds.has(p.id),
      }));
  }

  handlePlanChange(plan) {
    const index = this.selectedPlans.findIndex(
      (item) => item.planId === plan.id,
    );

    const isChecked = this.prescriptionForm.plans.includes(Number(plan.id));

    if (isChecked) {
      if (index === -1) {
        this.selectedPlans.push(
          {
            planId: plan.id,
            prescriptionId: this.prescriptionForm.id || null,
          },
        );
      }
    } else {
      if (index !== -1) {
        this.selectedPlans.splice(index, 1);
      }
    }
  }

  // No-75 Displays a list of non-clinic services
  // get unmatchedMenus() {
  //   const menuList = (this.$parent as any)?.listPlanByMenuKarte || [];
  //   return menuList.filter((menu) => menu.id !== this.activeTreatment?.menu?.id);
  // }

  prescriptionHandle() {
    this.isPrescription = true;
    this.prescriptionType = this.PRESCRIPTION_TYPE.PRESCRIPTION;
    this.prescriptionForm.type = this.PRESCRIPTION_TYPE.PRESCRIPTION;

    this.prescriptionForm.plans = [];
    this.selectedPlans = [];

    const self = this;
    setTimeout(function() {
      self.planSuggestListEl = document.querySelector('div.plan-suggest-list');
      self.planSuggestListEl?.addEventListener('scroll', self.handleScroll);
    }, 100);
  }

  ngHandle() {
    this.isNG = true;
    this.prescriptionType = this.PRESCRIPTION_TYPE.NG;
    this.prescriptionForm.type = this.PRESCRIPTION_TYPE.NG;
  }

  cancelPrescription() {
    this.isCancel = true;
    this.prescriptionType = this.PRESCRIPTION_TYPE.CANCEL_PRESCRIPTION;
    this.prescriptionForm.type = this.PRESCRIPTION_TYPE.CANCEL_PRESCRIPTION;
  }

  reservePrescription() {
    this.isReverse = true;
    this.prescriptionType = this.PRESCRIPTION_TYPE.RESERVE_PRESCRIPTION;
    this.prescriptionForm.type = this.PRESCRIPTION_TYPE.RESERVE_PRESCRIPTION;
  }

  handleScroll(event) {
    const container = event.target;
    const { scrollTop, scrollHeight, clientHeight } = container;

    // No-75 Displays a list of non-clinic services
    // if (scrollTop + clientHeight >= scrollHeight - 10 && !this.isLoading) {
    //   this.getListPlans();
    // }
  }

  async savePrescriptionForm() {
    const isValid = await this.prescriptionFormRef.validate();
    if (!isValid) {
      return;
    }
    const data = {
      user_id: this.currentChannelUser.id,
      content: this.prescriptionForm.content,
      plans:
        this.prescriptionForm.type === this.PRESCRIPTION_TYPE.PRESCRIPTION
          ? this.prescriptionForm.plans
          : null,
      type: this.prescriptionForm.type,
      user_treatment_id: this.activeTreatment.id,
    };
    this.isSubmitting = true;
    const self = this;

    if (this.prescriptionForm.id) {
      await ApiHelper.getApi('DoctorMouthApi')
        .updateFeedback(this.prescriptionForm.id, data)
        .then(function(res) {
          self.activeTreatment.state = res.userTreatment.state;
          self.activeTreatment.feedback_type = res.userTreatment.feedback_type;
          self.$store.commit('user_treatment_list/setUserTreatmentState', res.userTreatment);
          self.$store.commit('user_treatment_list/setUserTreatmentLatestAnswer', res.userTreatment);
        })
        .catch((error: any) => {
          error.response && Toast.error(error.response.data.message);
        })
        .finally(function() {
          self.isSubmitting = false;
          self.$modal.hide('prescriptionForm');
        });
    } else {
      // new feedback.
      await ApiHelper.getApi('PatientV2Api')
        .createFeedback(this.currentPatient.id, data)
        .then(function(res, error) {
          self.$emit('submit', res.data);
        })
        .catch((error: any) => {
          error.response && Toast.error(error.response.data.message);
        })
        .finally(function() {
          self.isSubmitting = false;
          self.$modal.hide('prescriptionForm');
        });
    }

    self.$emit('savedFeedback');
  }
}
